import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRealEstateDimensionsHouseRuler = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "real-estate-dimensions-house-ruler" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M11.25,17.25v3a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5v-3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M23.25,15.75,16.753,9.9a1.5,1.5,0,0,0-2.006,0L8.25,15.75"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 21.75,
			y1: 14.4,
			x2: 21.75,
			y2: 10.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M23.25,1.5A.75.75,0,0,0,22.5.75H1.5a.75.75,0,0,0-.75.75v21a.75.75,0,0,0,.75.75h3a.75.75,0,0,0,.75-.75V5.25H22.5a.75.75,0,0,0,.75-.75Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 3.75,
			y1: 11.25,
			x2: 5.25,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 3.75,
			y1: 17.25,
			x2: 5.25,
			y2: 17.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 11.25,
			y1: 5.25,
			x2: 11.25,
			y2: 3.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 17.25,
			y1: 5.25,
			x2: 17.25,
			y2: 3.75
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "0.75 5.25 5.25 5.25 5.25 0.75"
		})
	]
});
export default SvgRealEstateDimensionsHouseRuler;
